/**
 * Where the public pages link to each other.
 *
 * Both point at the React pages while the Struts ones at `/home/register` and `/` are still live. At
 * cutover each becomes its final URL and these two lines are the only edit - rather than every button
 * that happens to say "Join now" or carry the logo.
 */
export const REGISTER_URL = '/home/registerReact';
export const HOME_URL = '/home/homeReact';
